export default {
  title: 'WinOrder',
  form: {
    store_id: {
      label: 'Myymälätunnus: ',
    },
    url: {
      label: 'URL: ',
    },
    username: {
      label: 'Käyttäjätunnus: ',
      placeholder: 'Kaupan ja WinOrderin välisen todennuksen käyttäjätunnus',
      validation: {
        required: 'Käyttäjätunnus ei voi olla tyhjä',
        min: 'Käyttäjätunnuksen vähimmäispituus on 3 merkkiä',
      },
    },
    password: {
      label: 'Salasana: ',
      placeholder: 'Kaupan ja WinOrderin välisen todennuksen salasana',
      validation: {
        required: 'Salasana ei voi olla tyhjä',
        complexity: 'Salasanan tulee olla vähintään 8 merkkiä pitkä ja sisältää vähintään yhden kirjaimen',
      },
    },
  },
  labels: {
    credentials: 'Kirjautumistiedot:',
  },
  instructions: {
    title: 'Käyttöönotto-ohjeet:',
    step_1: 'Avaa WinOrderissa ”Asetukset” → ”Ohjelman asetukset”.',
    step_2: 'Yläreunasta löydät painikkeen ”Verkkokaupan asetukset”.',
    step_3:
      'Seuraavassa ikkunassa näet kaikki WinOrderiin esimääritetyt kaupat. Valitse ”FoodAmigos” ja napsauta sitten ”Seuraava”.',
    step_4:
      'Seuraavassa ikkunassa korvaa <0>{{storeid_placeholder}}</0> kohdalla <1>{{company_id}}</1> kentässä ”Verkkopalvelun URL”. <br />Lopputuloksen tulisi näyttää tältä: <2>{{url}}</2>',
    step_5: 'Syötä samassa ikkunassa <ClickToCopy>{{username}}</ClickToCopy> kenttään ”Käyttäjätunnus”.',
    step_6:
      'Syötä samassa ikkunassa <ClickToCopy>{{password}}</ClickToCopy> kenttään ”Salasana”. Napsauta sitten ”Seuraava”.',
    step_7:
      'WinOrder testaa nyt yhteyttä FoodAmigos-rajapintaan. Napsauta ”Seuraava” ja seuraavassa ikkunassa ”Valmis”.',
    step_8: 'Tallenna asetukset.',
  },
  buttons: {
    save: 'Tallenna',
    cancel: 'Peruuta',
    edit: 'Muokkaa',
  },
  toasts: {
    error: 'Muutosten tallentaminen epäonnistui',
    success: 'Muutokset tallennettiin',
  },
};
